// Override Settings
var boostPFSInstantSearchConfig = {
  search: {
      //suggestionMode: 'test'
      //suggestionPosition: 'left',
      suggestionWidth: 300,
  }
};

(function () {
  BoostPFS.inject(this);

  // Bind Event for input search Mobile
  var bindEventsMobile = InstantSearchMobile.prototype.bindEvents;
  InstantSearchMobile.prototype.bindEvents = function() {
    bindEventsMobile.call(this);

    var self = this;
    var searchButtonMobile = '.show-search-link, .site-nav--mobile .search-button, .js-search-destop';
    var searchInputMobile = '.search-input-group input[type="search"], .wg-search-form .search-input';
    var searchCloseButtonMobile = '.main-search__close, .drawer__close > button, .drawer_back a';
    jQ(searchButtonMobile).off('click').click(function(e) {
      e.preventDefault();
      //e.stopPropagation();
      jQ(searchInputMobile).focus();
      self.openSuggestionMobile();
      jQ(searchCloseButtonMobile).trigger('click');

    });
  }

  // Customize style of Suggestion box
  SearchInput.prototype.customizeInstantSearch = function(suggestionElement, searchElement, searchBoxId) {
    if(!suggestionElement) suggestionElement = this.suggestionElement;
    if(!searchElement) searchElement = this.searchElement;
    if(!searchBoxId) searchBoxId = this.searchBoxId;
  };

  InstantSearch.prototype.beforeBindEvents = function(id) {
    if(!id) id = this.id;
      jQ(document).ready(function() {
          jQ(document).off('submit', '.search-form, #search-form');
      });
  };

})();